import { render, staticRenderFns } from "./old.vue?vue&type=template&id=f079bc18&scoped=true&"
import script from "./old.vue?vue&type=script&lang=js&"
export * from "./old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f079bc18",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WLoading from '@/components/WLoading.vue'
import WOrders from '@/components/WOrders.vue'
import WSelect from '@/components/WSelect.vue'
import WTopBar from '@/components/WTopBar.vue'
autoInstallComponents(component, {WLoading,WOrders,WSelect,WTopBar})
